import type { ForumQuillEditorRef } from '@/modules/forum/components/ForumQuillEditor'
import { ForumQuillEditor } from '@/modules/forum/components/ForumQuillEditor'
import { quillValidation } from '@/utils/forms'
import { useOnErrorAuto } from '@/utils/hooks/error-handling'
import { useMutation } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import Delta from 'quill-delta'
import { useRef } from 'react'
import { CREATE_ABSENCE_COMMENTS_MUTATION } from './mutations'

interface CreateAbsenceCommentProps {
  absenceId: string
}

export function CreateAbsenceComment({ absenceId }: CreateAbsenceCommentProps) {
  const translations = useTranslate({
    comment: 'common.comment-ellipsis',
  })

  const quillRef = useRef<ForumQuillEditorRef>(null)
  const onErrorAuto = useOnErrorAuto()

  const [createCommentMutation, { loading }] = useMutation(
    CREATE_ABSENCE_COMMENTS_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AbsenceComments', 'AbsenceDetails'],
      onCompleted() {
        if (!quillRef.current) return
        quillRef.current.quill?.setContents(new Delta())
      },
      onError: onErrorAuto(),
    }
  )

  async function handleSubmit(content: string) {
    const delta = quillRef.current?.quill?.getContents()
    if (!quillValidation(delta)) return

    await createCommentMutation({
      variables: {
        input: {
          absence: absenceId,
          content: content,
        },
      },
    })
  }

  return (
    <ForumQuillEditor
      ref={quillRef}
      placeholder={translations.comment}
      loading={loading}
      noAttachments={false}
      hasImage={true}
      onSubmit={handleSubmit}
    />
  )
}
